import request from 'api/requestUtils'
import { paths } from '@luxuryescapes/contract-cart'
import { mapMultiCartUpdateItemResponse } from './multiCartMappers'
import { prepareItem } from 'lib/checkout/userCartPrepare'

type UpdateMultiCartRequest = paths['/api/carts/multi-carts/{multiCartId}/items']['put']['parameters']['body']['payload']
type UpdateMultiCartResponse = paths['/api/carts/multi-carts/{multiCartId}/items']['put']['responses']['200']['content']['application/json']

export function updateItemsInMultiCart(multiCartId: string, items: Array<App.Checkout.AnyItem>): Promise<Array<App.MultiCartItem>> {
  // remove this type-cast and change the villas type check
  const preparedItems = items.map(prepareItem) as UpdateMultiCartRequest['items']

  return request.put<UpdateMultiCartResponse, UpdateMultiCartRequest>(`/api/carts/multi-carts/${multiCartId}/items`, { items: preparedItems }, { credentials: 'include' }).then(mapMultiCartUpdateItemResponse)
}
